const Categories = {
  'Description has been already registered':
    'Já existe uma categoria com esse nome',
  'category is not a group':
    'Categoria principal pertence ao subgrupo, não é permitido criar uma categoria para o grupo dentro dela'
};

export default Categories;
